const initDropAHint = () => {
    const contextElement = document.querySelector('#drop-a-hint-context');
    const context = JSON.parse(contextElement.innerText);
    const FORM = document.querySelector('[data-drop-hint-form]');
    const inputs = FORM.querySelectorAll('input');
    const submitButton = FORM.querySelector('button');
    const formBody = document.querySelector('[data-drop-hint-body]');
    const successMessage = document.querySelector('[data-drop-hint-success]');
    const errorMessage = document.querySelector('[data-drop-hint-error]');
    const formState = {
        sender_name: '',
        sender_email: '',
        receiver_name: '',
        receiver_email: '',
        product_title: (context === null || context === void 0 ? void 0 : context.productTitle) || '',
        product_url: (context === null || context === void 0 ? void 0 : context.productURL) || '',
        product_image: `https:${context === null || context === void 0 ? void 0 : context.productImage}` || '',
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        handleKlaviyo();
    };
    FORM.addEventListener('submit', (e) => handleSubmit(e));
    submitButton.addEventListener('submit', (e) => handleSubmit(e));
    const handleInputChange = (e) => {
        formState[e.target.id] = e.target.value;
    };
    const handleSuccess = () => {
        formBody.setAttribute('style', 'display: none');
        successMessage.setAttribute('style', 'display: flex');
    };
    const handleError = () => {
        errorMessage.setAttribute('style', 'display: block');
    };
    const handleKlaviyo = () => {
        const options = {
            method: 'POST',
            headers: { Accept: 'text/html', 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                data: `{
            "token": "VcERvW",
            "event": "Drop a Hint",
            "customer_properties": {
                "$email": "${formState.receiver_email}"
            },
            "properties": {
                "sender_name": "${formState.sender_name}",
                "sender_email": "${formState.sender_email}",
                "receiver_name": "${formState.receiver_name}",
                "receiver_email": "${formState.receiver_email}",
                "product_url": "${formState.product_url}",
                "product_title": "${formState.product_title}",
                "product_image": "${formState.product_image}"
            }
        }`,
            }),
        };
        fetch('https://a.klaviyo.com/api/track', options)
            .then((response) => response.json())
            .then((response) => {
            if (response === 1)
                handleSuccess();
            if (response === 0)
                handleError();
        })
            .catch((err) => console.error(err));
    };
    [...inputs].forEach((input) => {
        input.addEventListener('input', (e) => handleInputChange(e));
    });
};
if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(() => {
        initDropAHint();
    }, 1);
}
else {
    document.addEventListener('DOMContentLoaded', () => {
        initDropAHint();
    });
}
